import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { clients, sender } from '../data/proposal';
import { BookingLink } from './BookingLink';
type IntroStatementProps = {
  onOpenConcept: () => void;
};
export function IntroStatement({
  onOpenConcept
}: IntroStatementProps) {
  return <section aria-labelledby="intro-title" className="max-w-[500px] text-ink" data-id="element-108" data-mp="12x1vrrec4r9r">
      <p className="font-mono text-[11px] font-medium tracking-[0.22em] text-teal" data-id="element-109" data-mp="oxsfysu1jz6b">A PERSONAL INTRODUCTION FROM SNAKKER</p>
      <h1 id="intro-title" className="mt-4 text-[34px] font-semibold leading-[1.05] tracking-[-0.035em] lg:text-[40px]" data-id="element-110" data-mp="txevj8xcdria">
        We took the liberty of <span className="text-graphite" data-id="element-111" data-mp="f1fom1lyxxeq">creating a Snak for you.</span>
      </h1>

      <div className="mt-5 space-y-3 text-[16px] leading-[1.55] text-graphite" data-id="element-112" data-mp="jzh7alfhfupo">
        <p data-id="element-113" data-mp="29ddv3vsw8f6x">
          Following a conversation with Martha, we took the liberty of creating a short interactive Study Data Snak inspired by
          the recent German MINT results for Poteligeo®.
        </p>
        <p data-id="element-114" data-mp="4b4wykzayrvv">
          Not because we presume to know your brand, market or priorities — but because we wanted to show how we bring{' '}
          <span className="text-ink" data-id="element-115" data-mp="3vgda8i2ae6bi">complex scientific knowledge to life in a short, sharp and rewarding format</span> for busy
          HCPs.
        </p>
        <p data-id="element-116" data-mp="93xxsxrnhg2o">
          We hope you’ll enjoy exploring the Snak on the right. It’s intended as an inspiration, not a recommendation.
        </p>
        <p data-id="element-117" data-mp="3hkstnta16079">
          And, admittedly, we’re hoping our little investment in creativity might earn us the opportunity to meet your team, show
          you more of our work and explore where we could make a difference together.
        </p>
      </div>

      <div className="mt-5" data-id="element-118" data-mp="3mhjf6w4lto02">
        <p className="text-[15px] font-semibold text-ink" data-id="element-119" data-mp="3mghudzxsdn55">{sender.name}</p>
        <p className="text-[13px] text-graphite" data-id="element-120" data-mp="15s4c6cedjmu5">
          {sender.role} ·{' '}
          <a href="https://www.snakker.io" target="_blank" rel="noopener noreferrer" className="text-navy underline decoration-navy/30 underline-offset-2 transition-colors duration-150 hover:decoration-navy" data-id="element-121" data-mp="11s3nlyxk9v9d">
            snakker.io
          </a>
        </p>
        <p className="mt-2 text-[12.5px] text-graphite/75" data-id="element-122" data-mp="8fvs9n0333r8">Experience with teams at {clients.join(' · ')} and others.</p>
      </div>

      <div className="mt-6 flex flex-col items-start gap-3.5" data-id="element-123" data-mp="cebmaaul1ce5">
        <BookingLink label="Let’s meet — book a short introduction" data-id="element-124" data-mp="3bwm0m8j51sw3" />
        <button type="button" onClick={onOpenConcept} className="group inline-flex items-center gap-1.5 text-[14px] font-medium text-navy transition-colors duration-150 hover:text-teal focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy" data-id="element-125" data-mp="3gue2nvdhyve0">
          Explore the concept &amp; other ideas
          <ArrowRightIcon size={15} strokeWidth={2} className="transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-126" data-mp="2t38nlifds74r" />
        </button>
      </div>

      <p className="mt-6 text-[11px] leading-snug text-graphite/60" data-id="element-127" data-mp="2pl1hch3wx4my">
        Independently developed illustrative concept based on publicly available information, without a formal Kyowa Kirin brief.
        Scientific content subject to appropriate medical, legal and regulatory review.
        <br data-id="element-128" data-mp="2bn34xh95jia3" />
        Idea, concept &amp; creative direction © Snakker™ 2026 · Confidential &amp; proprietary.
      </p>
    </section>;
}